import axios from "axios";
import config from "./globalConfig";
import CryptoJS from "crypto-js";

const k = "8080808080808080";
const s = 16;

export default {
  getCustomCookies: function getCustomCookies() {
    var myCooki = document.cookie;
    myCooki = myCooki.replace("=", "T");
    return myCooki;
  },
  captureFinger: function captureFinger(threshVal, callback) {
    let templateType = 2002;
    //2001-Suprema, 2002-ISO_19794_2, 2003 - ANSI378
    let delayVal = 40000;
    let captureTimeOutVal = 1000 * (60 * 2);
    //Timeout2 min
    axios
      .get(
        config.BIOMETRIC_PATH + "db/EkkCaptureSingleEx?dummy=" + Math.random(),
        {
          headers: {},
          params: {
            sHandle: "1",
            id: 0,
            Sensitivity: "6",
            TemplateType: templateType,
            QualityToCheck: threshVal,
            CustomCookiesData: this.getCustomCookies(),
            resetTimer: delayVal,
            CaptureTimeOut: captureTimeOutVal
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  verifyTemplateFinger: function verifyTemplateFinger(
    leftTemplate,
    rightTemplate,
    callback
  ) {
    let devicehandle = 0;
    let captureTimeOutVal = 1000 * (60 * 2);
    //Timeout2 min
    axios
      .get(
        config.BIOMETRIC_PATH +
          "db/EkkVerifyRecentFinger?dummy=" +
          Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            extractEx: 1,
            qualityLevel: 50,
            CustomCookiesData: this.getCustomCookies(),
            CaptureTimeOut: captureTimeOutVal,
            LeftFinger: this.convertToHex(leftTemplate),
            RightFinger: this.convertToHex(rightTemplate),
            IsMergeTemplate: "0"
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  matchDuplicateFinger: function matchDuplicateFinger(
    leftTemplate,
    rightTemplate,
    token,
    callback
  ) {
    let captureTimeOutVal = 1000 * (60 * 1);
    //Timeout2 min
    let projectID = "PROJECTID_ORDCRA";
    let rallyID = "-1";
    let postTypeID = "-1";
    let eventID = "1";
    let eventRMDSNo = "";
    let ceeDate = "1900-01-01";
    let devicehandle = 0;
    axios
      .get(
        config.BIOMETRIC_PATH +
          "db/EkkCheckDuplicateFinger?dummy=" +
          Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            extractEx: 1,
            qualityLevel: 50,
            CustomCookiesData: this.getCustomCookies(),
            ConnectionStr: token,
            ProjectID: projectID,
            CEEDate: ceeDate,
            RallyID: rallyID,
            PostTypeID: postTypeID,
            EventID: eventID,
            RolloNo: eventRMDSNo,
            CaptureTimeOut: captureTimeOutVal,
            LeftFinger: this.convertToHex(leftTemplate),
            RightFinger: this.convertToHex(rightTemplate),
            RefreshDataBuffer: 0,
            IsAccrossRally: "1"
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  matchDuplicateUserFinger: function matchDuplicateUserFinger(
    leftTemplate,
    rightTemplate,
    token,
    callback
  ) {
    let captureTimeOutVal = 1000 * (60 * 1);
    //Timeout2 min
    let projectID = "PROJECTID_ORDCRA";
    let rallyID = "-1";
    let postTypeID = "-1";
    let eventID = "1";
    let eventRMDSNo = "";
    let ceeDate = "1900-01-01";
    let devicehandle = 0;
    axios
      .get(
        config.BIOMETRIC_PATH +
          "db/EkkCheckUserDuplicateFinger?dummy=" +
          Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            extractEx: 1,
            qualityLevel: 50,
            CustomCookiesData: this.getCustomCookies(),
            ConnectionStr: token,
            ProjectID: projectID,
            CEEDate: ceeDate,
            RallyID: rallyID,
            PostTypeID: postTypeID,
            EventID: eventID,
            RolloNo: eventRMDSNo,
            CaptureTimeOut: captureTimeOutVal,
            LeftFinger: this.convertToHex(leftTemplate),
            RightFinger: this.convertToHex(rightTemplate),
            RefreshDataBuffer: 0
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  verifyFinger: function verifyFinger(
    { advtID, eventID, postTypeID, appSerialNo, ceeDate, token },
    callback
  ) {
    let captureTimeOutVal = 1000 * (60 * 1);
    //Timeout2 min
    let projectID = "PROJECTID_ORDCRA";
    let securitylevel = "5";
    let devicehandle = 0;
    axios
      .get(
        config.BIOMETRIC_PATH + "db/EkkVerifyFinger?dummy=" + Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            extractEx: 1,
            //cb_ExtractExMode,
            qualityLevel: 50,
            CustomCookiesData: this.getCustomCookies(),
            ConnectionStr: token,
            ProjectID: projectID,
            CEEDate: ceeDate,
            RallyID: advtID,
            PostTypeID: postTypeID,
            EventID: eventID,
            RolloNo: appSerialNo,
            SecurityLevel: securitylevel,
            CaptureTimeOut: captureTimeOutVal,
            RefreshDataBuffer: 1
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  verifyUserFinger: function verifyUserFinger(token, callback) {
    let captureTimeOutVal = 1000 * (60 * 1);
    //Timeout2 min
    let projectID = "PROJECTID_ORDCRA";
    let devicehandle = 0;
    axios
      .get(
        config.BIOMETRIC_PATH + "db/EkkVerifyUserFinger?dummy=" + Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            extractEx: 1,
            qualityLevel: 50,
            CustomCookiesData: this.getCustomCookies(),
            ConnectionStr: token,
            ProjectID: projectID,
            CaptureTimeOut: captureTimeOutVal,
            RefreshDataBuffer: 0
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  capturePhoto: function capturePhoto(callback) {
    let devicehandle = 0;
    axios
      .get(
        config.BIOMETRIC_PATH + "db/EkkCapturePhoto?dummy=" + Math.random(),
        {
          headers: {},
          params: {
            sHandle: devicehandle,
            id: 0,
            CustomCookiesData: this.getCustomCookies()
          },
          crossdomain: true
        }
      )
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },
  convertToHex: function convertToHex(str) {
    var hex = "";
    for (var i = 0; i < str.length; i++) {
      hex += str.charCodeAt(i).toString(16);
    }
    return hex;
  },
  ekkScanQR(callback) {
    var projectID = "PROJECTID_ORDCRA";
    var devicehandle = 0;
    //alert('Called');
    axios
      .get(config.BIOMETRIC_PATH + "db/EkkScanQR?dummy=" + Math.random(), {
        headers: {},
        params: {
          sHandle: devicehandle,
          id: 0,
          CustomCookiesData: this.getCustomCookies(),
          ProjectID: projectID
        },
        crossdomain: true
      })
      .then(
        response => {
          callback(response);
        },
        error => {
          // if (request.readyState == 0) {
          //   return alert('Please check web agent is not running..');
          // }
          // else {
          return error;
          //}
        }
      );
  },
  openApplication: function openApplication(
    appPath,
    varParam,
    varParam1,
    callback
  ) {
    let varAppType = "Task";
    axios
      .get(config.BIOMETRIC_PATH + "db/EkkOpenApp?dummy=" + Math.random(), {
        headers: {},
        params: {
          sHandle: "1",
          id: 0,
          CustomCookiesData: this.getCustomCookies(),
          AppType: varAppType,
          AppPath: this.convertToHex(appPath),
          Param: varParam,
          Param1: varParam1
        },
        crossdomain: true
      })
      .then(
        response => {
          callback(response.data);
        },
        error => {
          console.log(error);
        }
      );
  },

  computeHash: function computeHash(str) {
    let result = "";
    let salt = CryptoJS.lib.WordArray.random(64 / 8).toString();

    let hashData = str + salt;
    salt = CryptoJS.enc.Utf8.parse(salt);
    let pwd = CryptoJS.SHA512(hashData);
    let hashWithSalt = pwd.concat(salt);
    pwd = CryptoJS.enc.Base64.stringify(hashWithSalt);
    result = pwd.toString();
    return result;
  },
  encryptAES: function encryptAES(str) {
    let result = "";
    let key = CryptoJS.enc.Utf8.parse(k);
    let iv = CryptoJS.enc.Utf8.parse(k);
    result = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), key, {
      keySize: s,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return result;
  },
  decryptAES: function decryptAES(str) {
    let result = '';
    let key = CryptoJS.enc.Utf8.parse(k);
    let iv = CryptoJS.enc.Utf8.parse(k);
    result = CryptoJS.AES.decrypt(
          str,
          key,
          {
            keySize: s,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        ).toString(CryptoJS.enc.Utf8);
    return result;
  },
};



// WEBPACK FOOTER //
// ./src/router/biometric.js